import { ReactElement } from "react";
import { CalendarCell } from "./CalendarCell";
import { getShortWeekDayNames } from "client/DateAndTime/culture";
import styles from "./WeekDays.module.less";
import { generateTrackingId } from "client/Misc/utils";

export type WeekDaysProps = {
	firstWeekDay: number;
};

export const WeekDays = (props: WeekDaysProps): ReactElement => {
	const {
		firstWeekDay
	} = props;

	const dayNames: readonly string[] = getShortWeekDayNames(firstWeekDay);

	return (
		<div
			className={styles.root}
			role="row"
		>
			{dayNames.map((x, i) => (
				<CalendarCell
					trackingId={generateTrackingId("week-day", `|${i}`)}
					key={i}
					kind="header"
				>
					{ x }
				</CalendarCell>
			))}
		</div>
	);
};
WeekDays.displayName = "WeekDays";
